<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6667 3.33325H3.33341C3.11454 3.33325 2.89782 3.37636 2.69561 3.46012C2.4934 3.54388 2.30967 3.66664 2.1549 3.82141C2.00014 3.97617 1.87737 4.1599 1.79362 4.36211C1.70986 4.56432 1.66675 4.78105 1.66675 4.99992V14.9999C1.66675 15.2188 1.70986 15.4355 1.79362 15.6377C1.87737 15.8399 2.00014 16.0237 2.1549 16.1784C2.30967 16.3332 2.4934 16.456 2.69561 16.5397C2.89782 16.6235 3.11454 16.6666 3.33341 16.6666H16.6667C16.8856 16.6666 17.1023 16.6235 17.3046 16.5397C17.5068 16.456 17.6905 16.3332 17.8453 16.1784C18 16.0237 18.1228 15.8399 18.2065 15.6377C18.2903 15.4355 18.3334 15.2188 18.3334 14.9999V4.99992C18.3334 4.78105 18.2903 4.56432 18.2065 4.36211C18.1228 4.1599 18 3.97617 17.8453 3.82141C17.6905 3.66664 17.5068 3.54388 17.3046 3.46012C17.1023 3.37636 16.8856 3.33325 16.6667 3.33325ZM16.6667 4.99992V11.6666H13.5334C13.2755 11.6673 13.0242 11.7478 12.8138 11.897C12.6034 12.0462 12.4444 12.2568 12.3584 12.4999C12.1866 12.9882 11.8675 13.4112 11.4451 13.7104C11.0226 14.0096 10.5177 14.1703 10.0001 14.1703C9.48242 14.1703 8.97753 14.0096 8.5551 13.7104C8.13267 13.4112 7.81353 12.9882 7.64175 12.4999C7.55578 12.2568 7.39672 12.0462 7.18636 11.897C6.976 11.7478 6.72464 11.6673 6.46675 11.6666H3.33341V4.99992H16.6667Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Inbox',
} as DefineComponent
</script>
